<template>
  <div v-if="tendersList || filteredTenders">
    <v-layout style="height: 100vh">
      <v-flex
        sm12
        md6
        style="background: #ececec; position: relative"
        class="pa-2 pt-0 left-bar"
        relative
      >
        <v-layout
          :style="{ marginTop: addTenderButtonOffset + 'px' }"
          v-if="type === 'myTenders' || type === 'draftTenders'"
        >
          <v-flex class="d-flex justify-center">
            <v-btn color="primary lighten-1" outlined xLarge @click="navigateToAddMyTenderPage">
              <translate> add a tender </translate>
            </v-btn>
          </v-flex>
        </v-layout>
        <div
          v-if="!tenders && !filteredTenders && type !== 'myTenders' && type !== 'draftTenders'"
          style="position: relative; height: 100%; width: 100%"
        >
          <div class="choose-tender">
            <translate v-if="type === 'starredTenders'">
              Please choose a favorite tender
            </translate>
            <translate v-else> There are no tenders </translate>
            <br />
            <v-icon>star</v-icon>
            <v-btn
              v-if="type === 'starredTenders'"
              style="display: block"
              text
              color="primary"
              class="ma-auto mt-3"
              :to="{ name: 'tenders' }"
            >
              <v-icon class="mr-4">launch</v-icon>
              <translate> All Tenders </translate>
            </v-btn>
          </div>
        </div>
        <v-layout
          v-if="tenders || (filteredTenders && filteredTenders.length)"
          wrap
          id="moe"
          ref="scrolling"
          @wheel="onScroll"
          v-touch="{ down: () => onScroll() }"
        >
          <v-flex
            v-for="(tender, index) in filteredTenders ? filteredTenders : tenders"
            :key="index"
            sm12
            md4
            class="pa-2 left-bar"
            :id="tender.id || tender.mpID"
            :ref="'tender'"
          >
            <tender-card @choose-tender="chooseTender(tender)"
                         @update="onTenderUpdate($event, tender)"
                         :tender="tender"
                         :highlighted="(openTender && (openTender.id || openTender.mpID)) === (tender.id || tender.mpID)"
                         :tender-detail-route-path="tenderDetailRoutePath" />
          </v-flex>
        </v-layout>
        <div class="d-flex justify-center align-center py-4" v-if="ifPendingResponse">
          <v-progress-circular :value="20" indeterminate color="primary"></v-progress-circular>
        </div>
        <v-layout
          align-center
          v-if="filteredTenders && !filteredTenders.length"
          style="position: absolute; top: 0; left: 0; height: 100%; width: 100%"
        >
          <v-flex xs12>
            <div class="text-center">
              <span theme--light class="text-uppercase" v-translate>No tenders found</span>
            </div>
            <div>
              <v-btn
                style="display: block"
                text
                color="primary"
                class="ma-auto mt-3"
                @mousedown="discardSearchResult"
              >
                <v-icon class="mr-4">launch</v-icon>
                <translate> All Tenders </translate>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        v-if="!$vuetify.breakpoint.xsOnly"
        xs12
        md6
        style="background: #ececec; position: relative"
        class="pl-2 pt-2 right-bar"
      >
        <div v-if="openTender">
          <v-card>
            <div style="position: relative">
              <router-link
                :to="{ path: tenderDetailRoutePath + '/' + (openTender.id || openTender.mpID) }"
                v-if="!['myTenders', 'draftTenders'].includes(type) && openTender.items"
              >
                <v-sheet
                  v-if="!getImage(openTender.items[0].classification.id)"
                  style="height: 45vh"
                  class="grey lighten-2"
                ></v-sheet>
                <v-img
                  v-else
                  :src="getImage(openTender.items[0].classification.id)"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  max-width="100%"
                  max-height="45vh"
                ></v-img>
              </router-link>
              <router-link
                :to="{ path: tenderDetailRoutePath + '/' + (openTender.id || openTender.mpID) }"
                v-else
              >
                <v-sheet
                  v-if="!openTender.category"
                  style="height: 45vh"
                  class="grey lighten-2"
                ></v-sheet>
                <v-img
                  v-else
                  :src="getImage(openTender.category)"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  max-width="100%"
                  max-height="45vh"
                >
                </v-img>
              </router-link>
              <v-card
                elevation-3
                style="
                  position: absolute;
                  right: 20px;
                  top: 20px;
                  background: #ffffff;
                  border-radius: 4px;
                  padding: 4px;
                "
              >
                <v-btn
                  :to="{ path: tenderDetailRoutePath + '/' + (openTender.id || openTender.mpID) }"
                  class="px-0 py-0"
                  text
                  style="height: auto; min-width: 0"
                >
                  <v-icon class="cursor-pointer" size="28">open_in_new</v-icon>
                </v-btn>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" text class="cursor-pointer" size="28">more_vert</v-icon>
                  </template>
                  <v-list dark v-if="itemsNavigationTypes.includes(type)">
                    <v-list-item
                      v-for="(item, index) in itemsNavigation"
                      :key="index"
                      @click="tenderAction(openTender.id, item)"
                    >
                      <v-list-item-title>
                        <translate>
                          {{ item.title }}
                        </translate>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card>
            </div>
            <v-card-text style="position: relative; background: #d9d9d9" class="pa-7">
              <v-fab-transition>
                <v-btn
                  :color="isOpenTenderStarred ? 'amber darken-1' : 'white'"
                  dark
                  absolute
                  top
                  right
                  fab
                  @click="toggleStarredStatus(openTender.id)"
                >
                  <v-icon color="black">star</v-icon>
                  <!-- <v-icon v-else @click="removeFromFavorite(openTender)" color="black">delete_forever</v-icon> -->
                </v-btn>
              </v-fab-transition>
              <router-link
                :to="{ path: tenderDetailRoutePath + '/' + (openTender.id || openTender.mpID) }"
                class="cursor-pointer tender-header"
                :title="openTender.title"
              >
                {{ substringText(openTender.title, 200) }}
              </router-link>
              <!-- <v-btn color="accent" @click="$store.commit('setAppErrorCardState', {state: true, errorText: 'My error has something strange about itself'})">Click me</v-btn> -->
              <v-layout justify-space-between align-end class="mt-2">
                <v-flex md8>
                  <span style="font-size: 13px" :title="openTender.description">
                    {{ categoryDescription }}
                  </span>
                </v-flex>
                <v-flex v-if="openTender.value" md4 class="text-right">
                  <span style="font-size: 20px; font-family: 'Montserrat-Medium', sans-serif">
                    {{ openTender.value.amount | moneyFormat(openTender.value.currency) }}
                  </span>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text style="position: relative" class="pa-6 pl-7">
              <v-layout>
                <v-flex class="mr-7" style="flex-grow: initial">
                  <v-avatar>
                    <img src="@/assets/img/avatar.png" alt="John" />
                  </v-avatar>
                </v-flex>
                <v-flex>
                  <p v-if="this.openTender.procuringEntity">
                    <strong>Published by </strong>
                    <a href="#" @click.prevent="openOrgInfoModal">
                      {{ this.openTender.procuringEntity.name }}
                    </a>
                  </p>
                  <p v-if="openTender.tenderPeriod" :style="{ color: formattedEndDate.color }">
                    {{ formattedEndDate.text }}
                  </p>
                  <p>{{ openTender.description }}</p>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </div>
        <div v-else class="choose-tender">
          <div v-if="tenders.length">
            <translate> Please choose a tender </translate>
            <br />
            <v-icon>touch_app</v-icon>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import GlobalFunctions from '@/utils/GlobalFunctions'
// import TenderApi from '@/services/apiCalls/tenders/tenders'
// import Search from '@/utils/Search'
// import Vue from 'vue'
import elementsForSearch from '@/assets/js/search/search'
import InfiniteScroll from 'vue-infinite-scroll'
import starredMixin from '@/mixins/starredMixin'
import getStatusColor from '@/utils/getStatusColor'
import { TENDER_STATUSES } from '@/constants/tenderStatuses'
import TenderCard from '@/components/app/tenders/TenderCard'

// import ErrorParser from '@/services/helpers/ErrorParser'
// import CheckOrganizationWrapper from '../../services/CheckOrganizationWrapper'

export default {
  name: 'Tenders',
  components: { TenderCard },
  props: {
    searchToRequest: {
      type: Object,
    },
    type: {
      type: String,
    },
    tendersList: {
      type: Array || null,
      default: () => {
        return [];
      },
    },
    listTenders: {
      type: Function,
      default: () => {},
    },
  },

  directives: { InfiniteScroll },

  mixins: [ starredMixin ],

  data() {
    return {
      searchPrefix: '',
      showMenu: false,
      showSearchTypes: [],
      itemsSearch: elementsForSearch,
      itemsSearchByType: [],
      currentItemSearch: null,
      ifPendingResponse: false,
      offsetTop: 0,
      dialogOpenTender: false,
      searchText: '',
      showSearch: false,
      itemsNavigation: [{ title: 'Add to favorite', function: 'addTenderToStarred' }],
      openTender: false,
      isOpenTenderAddedToFavorites: false,
      tenders: this.tendersList,
      filteredTenders: this.$store.state.search.filteredTenders,
      addTenderButtonOffset: 0,
      itemsNavigationTypes: [
        'allTenders',
        'todayTenders',
        'myTenders',
        'draftTenders',
        'myBidsTenders',
        'draftBidsTenders',
        'openTenders',
      ],
    }
  },

  watch: {
    '$store.state.search.filteredTenders'(newValue) {
      this.filteredTenders = newValue
      if (
        newValue &&
        newValue.length &&
        (!this.$route.query || (this.$route.query && !this.$route.query.id))
      ) {
        this.chooseTender(newValue[0])
      }
      if (newValue && newValue.length && this.$route.query && this.$route.query.id) {
        const tenderToPut =
          newValue.find((tender) => (tender.id || tender.mpID) === this.$route.query.id) ||
          newValue[0]
        this.chooseTender(tenderToPut)
      }
    },
    tendersList(newValue, oldValue) {
      this.tenders = newValue
      if (!oldValue && newValue && newValue.length) {
        this.chooseTender(newValue[0])
      }
      if (newValue && newValue.length && this.$route.query && this.$route.query.id) {
        const tenderToPut =
          newValue.find((tender) => (tender.id || tender.mpID) === this.$route.query.id) ||
          newValue[0]
        this.chooseTender(tenderToPut)
      }
    },
    $route() {
      if (
        this.openTender &&
        (this.openTender.id || this.openTender.mpID) !== this.$route.query.id
      ) {
        this.openTender = this.$_.findWhere(this.tenders, {
          id: this.$route.query.id,
        })
      }
    },
  },

  created() {
    this.$store.commit('navigation', false)

    this.handleTenderShowingOnFirstRender()
    this.$gettext('Add to favorite')
    this.$gettext('Remove from favorite')
    this.handleOpenTenderPresence()
  },

  mounted() {
    // this.getButtonOffset()
    if (this.type) {
      localStorage.setItem('currentTenders', this.type)
      this.$store.commit('setCurrentTenderType', this.type)
    }
    // document.addEventListener('click', this.handleDocumentClick)
  },

  computed: {
    formattedEndDate() {
      if (this.openTender && this.openTender.tenderPeriod) {
        const status = this.openTender.status;
        let endDate = status === TENDER_STATUSES.ACTIVE_TENDERING
          ? this.openTender.tenderPeriod.endDate
          : this.openTender.dateModified;
        if (endDate) {
          endDate = this.$moment(endDate).format('ll');
        } else {
          return { text: null, color: '#fff' };
        }
        const prefixes = {
          [TENDER_STATUSES.DRAFT]: '',
          [TENDER_STATUSES.ACTIVE_TENDERING]: 'Tendering until ',
          [TENDER_STATUSES.ACTIVE_QUALIFICATION]: 'Qualification on ',
          [TENDER_STATUSES.ACTIVE_AWARDED]: 'Awarded on ',
          [TENDER_STATUSES.COMPLETE]: 'Complete on ',
          [TENDER_STATUSES.CANCELED]: 'Canceled on ',
        };
        return {
          text: prefixes[status] ? prefixes[status] + endDate : endDate,
          color: getStatusColor(status),
        }
      } else {
        return null;
      }
    },

    tenderDetailRoutePath() {
      if (this.type === 'allTenders' || this.type === 'openTenders' || this.type === 'starredTenders') {
        return '/tenders'
      }
      if (this.type === 'prozorroTenders') {
        return '/prozorro-tenders'
      }
      if (this.type === 'myTenders' || this.type === 'draftTenders') {
        return '/my-tenders'
      }
      if (this.type === 'myBidsTenders') {
        return '/my-bids-tenders'
      }
      if (this.type === 'myDraftBidsTenders') {
        return '/my-draft-bids-tenders'
      }
    },
    tendersTitle() {
      this.$gettext('Starred Tenders')
      this.$gettext('Today Tenders')
      if (this.type === 'allTenders') {
        return this.$gettext('All Tenders')
      } else if (this.type === 'starredTenders') {
        return this.$gettext('Starred Tenders')
      } else if (this.type === 'todayTenders') {
        return this.$gettext('Today Tenders')
      } else if (this.type === 'myBidsTenders') {
        return this.$gettext('My Bids')
      } else if (this.type === 'draftBidsTenders') {
        return this.$gettext('Draft Bids')
      } else if (this.type === 'openTenders') {
        return this.$gettext('Open Tenders')
      }
      return ''
    },
    categoryDescription() {
      if (this.openTender && this.openTender.items && this.openTender.items[0]) {
        return `${
          this.$store.state.i18n.translations[this.$store.state.i18n.locale][
            `cpv.${this.openTender.items[0].classification.id}`
          ]
        } (${this.openTender.items[0].classification.id})`
      } else if (this.openTender) {
        return `
                ${
                  this.$store.state.i18n.translations[this.$store.state.i18n.locale][
                    `cpv.${this.openTender.category}`
                  ]
                } (${this.openTender.category})`
      }
      return ''
    },
    isOpenTenderStarred() {
      return this.openTender && this.$store.state.starredTendersIds.includes(this.openTender.id)
    },
  },

  methods: {
    onTenderUpdate(ev, tender) {
      tender.status = ev.status;
    },

    openOrgInfoModal() {
      this.$root.openOrganizationInfoDialog(this.openTender.procuringEntity.identifier);
    },

    discardSearchResult() {
      this.$router.push({
        name: 'tenders',
      })
      this.$store.commit('search/discardSearch')
    },
    handleTenderShowingOnFirstRender() {
      const tenders = (this.filteredTenders && this.filteredTenders) || this.tenders

      if (tenders && tenders.length) {
        if (this.$route.query && this.$route.query.id) {
          const tenderToPut =
            tenders.find((tender) => (tender.id || tender.mpID) === this.$route.query.id) ||
            tenders[0]
          this.chooseTender(tenderToPut)
        } else {
          this.chooseTender(tenders[0])
        }
      }
    },
    handleScrollToTopButton() {
      const firstTenderTopCoord = this.$refs.tender[0].getBoundingClientRect().top
      if (firstTenderTopCoord < -1000) {
        this.$store.commit('changeScrollToButtonState', false)
      } else {
        this.$store.commit('changeScrollToButtonState', true)
      }
    },
    onScroll() {
      if (!this.tenders && !this.filteredTenders) return
      // this.handleScrollToTopButton()
      const tenders = this.tenders || this.filteredTenders
      if (
        this.$refs.tender[tenders.length - 1].offsetTop +
          this.$refs.scrolling.getBoundingClientRect().top <
          950 &&
        !this.ifPendingResponse
      ) {
        this.getMoreTenders()
      }
    },
    async getMoreTenders() {
      this.ifPendingResponse = true
      try {
        if (this.filteredTenders) {
          await this.$store.dispatch('search/getFilteredTendersBySearch', {
            from: this.filteredTenders.length,
            type: this.$route.query.searchType,
            text: this.$route.query.searchText,
          })
        } else {
          await this.listTenders()
        }
        this.ifPendingResponse = false
      } catch {
        this.ifPendingResponse = false
      }
    },

    navigateToAddMyTenderPage() {
      //Procedure Type selection has been skipped since only one type exists.
      //Uncomment this code in case new Procedure Type is added.
      // this.$router.push({ name: 'addnewprocurement' })

      this.$router.push({ name: 'addmynewtender' })
    },
    tenderAction(tender, item) {
      this[item.function](tender)
    },
    getImage(cpv) {
      const img = GlobalFunctions.findCpvImage(cpv)
      if (img) {
        return require('@/assets/img/tenderCpvImg/' + img)
      } else {
        return ''
      }
    },
    chooseTender(tender) {
      const id = tender.id || tender.mpID
      this.openTender = tender
      if (this.$vuetify.breakpoint.xsOnly) {
        this.dialogOpenTender = true
      }
      if (this.type === 'prozorroTenders' && this.filteredTenders) {
        this.$router.push({
          name: `${this.type.toLowerCase()}`,
          query: { ...this.$route.query, id },
        }).catch(() => {})
      } else if (this.type === 'allTenders') {
        this.$router.push({ name: 'tenders', query: { id } }).catch(() => {})
      } else if (this.type === 'starredTenders') {
        this.$router.push({ name: 'starred', query: { id } }).catch(() => {})
      } else if (
        [
          'myTenders',
          'draftTenders',
          'myBidsTenders',
          'myDraftBidsTenders',
          'openTenders',
          'prozorroTenders',
        ].includes(this.type)
      ) {
        this.$router.push({
          name: `${this.type.toLowerCase()}`,
          query: { id },
        }).catch(() => {})
      }
    },
    // handleDocumentClick(e) {
    //     if (
    //         this.showMenu &&
    //         !e.target.className.includes('v-menu__content') &&
    //         !e.target.className.includes('v-input')
    //     ) {
    //         this.showMenu = false
    //     }
    // },
    substringText(text, length) {
      return GlobalFunctions.substring(text, length)
    },
    openTenderDetail(tender) {
      this.$router.push({ name: 'tenderDetail', params: tender })
    },
    navigateToAllTenders() {
      this.$router.push({ name: 'tenders' })
    },
    handleOpenTenderPresence() {
      if (this.$route.query.id) {
        this.openTender = this.$_.findWhere(this.tenders, {
          id: this.$route.query.id,
        })
      }
    },
  },
}
</script>

<style scoped>
header.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-app-bar.transparent {
  box-shadow: none;
}

.choose-tender {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  cursor: default;
}

.cursor-pointer {
  transition: 0s;
}

.tender-header {
  font-family: 'Ubuntu', sans-serif;
  font-size: 20px;
  line-height: 1.8rem;
  color: rgba(0, 0, 0, 0.54);
  text-decoration: none;
  font-weight: 600;
}

.v-toolbar.v-sheet {
  transition: none;
}
.tender--highlighted {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
</style>